import React from 'react';
import './Events.css';

const Events = ({ currentLanguage }) => {
  const getTranslation = (key) => {
    const translations = {
      en: {
        title: 'Recent Cosmic Events',
        subtitle: 'Celebrating milestones in our spiritual journey'
      },
      hi: {
        title: 'हाल की ब्रह्मांडीय घटनाएं',
        subtitle: 'हमारी आध्यात्मिक यात्रा के मील के पत्थर मनाना'
      },
      gu: {
        title: 'તાજેતરની કોસ્મિક ઘટનાઓ',
        subtitle: 'અમારી આધ્યાત્મિક યાત્રાના લક્ષ્યોની ઉજવણી'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  const events = [
    {
      id: 1,
      image: '/images/events/event3.jpeg',
      title: 'International Astrology Conference',
      description: 'Master Ankit was the keynote speaker at the prestigious International Vedic Astrology Conference in New Delhi.'
    },
    {
      id: 2,
      image: '/images/events/event2.jpeg',
      title: 'National Television Feature',
      description: 'Featured as the main astrology expert on Zee TV\'s prime time show.'
    },
    {
      id: 3,
      image: '/images/events/event1.jpeg',
      title: 'Book Launch: "Cosmic Whispers"',
      description: 'The grand launch of Master Ankit\'s latest book at the India International Centre.'
    },
    {
      id: 4,
      image: '/images/events/event4.jpeg',
      title: 'Spiritual Healing Workshop',
      description: 'An intensive workshop on spiritual healing techniques attended by over 200 participants.'
    }
  ];

  return (
    <section id="events" className="events">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{getTranslation('title')}</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">{getTranslation('subtitle')}</p>
        </div>
        <div className="events-grid">
          {events.map((event) => (
            <div key={event.id} className="event-card">
              <div className="event-image">
                <img src={event.image} alt={event.title} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;